import React from 'react';
import {
  IProductSectionContext,
  productSectionBlockName,
  ProductSectionContext,
} from '../ProductSection/ProductSection';
import HTMLParser from '@gik/ui/HTMLParser/HTMLParser';
import { productHasAffiliateRelationship, productIsAffiliate } from '@gik/checkout';
import bemBlock from '@gik/core/utils/bemBlock';

export default function ProductDescription() {
  const bem = bemBlock(productSectionBlockName);

  const { product } = React.useContext<IProductSectionContext>(ProductSectionContext);

  return (
    <div className={bem('product-description')}>
      {/* TODO: UI Article component */}
      <div className={bem('description', undefined, 'gik-article')}>
        <HTMLParser rawHtml={product.description} />
      </div>

      {productIsAffiliate(product) && product.sources && product.sources.length && (
        <div className={bem('note')}>
          Payment fulfillment by {product.sources[0].name}. Give InKind has an affiliate relationship with many of the
          advertisers on our site, and may receive a commission from products purchased via this link.
        </div>
      )}

      {productHasAffiliateRelationship(product) && (
        <div className={bem('tango-card-disclaimer')}>
          <p>
            Give InKind has an affiliate relationship with many of the advertisers on our site, and may receive a
            commission from products purchased.
          </p>
        </div>
      )}

      {product.disclaimer && (
        <div className={bem('disclaimer')}>
          <HTMLParser rawHtml={product.disclaimer} />
        </div>
      )}

      {product.terms && (
        <div className={bem('terms')}>
          <HTMLParser rawHtml={product.terms} />
        </div>
      )}
    </div>
  );
}
